// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"459":"18a692d1","644":"ee9f430e"}[chunkId] + ".chunk.css";
};